// extracted by mini-css-extract-plugin
export default {"icon":"_10t8mUqqRVmOJu9xhCV-y2","align":"_3VrjGrHJP7Be6IZNy6vDxZ","header":"_2CByO6VOGNnoERYL2NSG_m","text":"_1COVjb3cp_A6L7ENNEDQGZ"};